// extracted by mini-css-extract-plugin
module.exports = {"root":"_de0966"};